<template>
  <div>
      <button v-if="status" class="btn btn-primary" :class="{ 'disabled': disabledBtn, '': !disabledBtn }" @click="getCheckout">
        Einfach und direkt bezahlen
    </button>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
export default {
  name: 'Sofort',
  data: () => ({
    status: true,
    disabledBtn: false
  }),
  computed: {
    ...mapGetters({
      orderId: 'checkout/orderId',
      price: 'checkout/price'
    })
  },
  methods: {
    async getCheckout () {
      this.$root.$refs.loading.start()
      const data = {
        re: apiKey,
        order_id: this.orderId,
        amount: this.price.total,
        domain: window.location.origin
      }
      const apiUrl = process.env.VUE_APP_API_URL
      const apiKey = btoa(process.env.VUE_APP_API_KEY)
      await axios.post(apiUrl + 'sofort/checkout', data).then(resp => {
        if (resp.data.status) {
          this.status = false
          this.disabledBtn = false
          this.$root.$refs.loading.finish()
          // redirect to sofort checkout
          window.location.href = res.data.url
        } else {
          this.disabledBtn = true
          this.status = true
        }
      })
    }
  }
}
</script>
